import styled, {css} from "styled-components";

export const OpenContainerBox = styled.div<{isOpen?: boolean}>`
  display: block;
  transition: all 0.2s ease-in;
  max-height: 0;
  overflow: hidden;
  
  ${({isOpen}) => isOpen && css`max-height: 100vh`};
`;